import type { FaireProductEntity } from "../../entity_types/product";

export const p_nvahamkwmj: FaireProductEntity = {
  token: "p_nvahamkwmj",
  type: "product",
  name: 'Dome Shade LED Lamp-10"H',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/97ea433783c6ab7d318b4e6eb30c3bb2fb51f0b5b5081f089b39ad64ffb0ac82.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3cf8044acb5d546f94fca16cb6970cb637137db1ccd1adff6fdc89b198e5e2df.jpeg",
    "https://cdn.faire.com/fastly/2958ce78cb612ee67c438060cccbb3d03051312145eeb817382274f14594b030.jpeg",
    "https://cdn.faire.com/fastly/f22825e48aa7efb9f30a93ab89cbf6ad79a532188a412cd674fd7dff1a55c367.jpeg",
    "https://cdn.faire.com/fastly/218a2e25a23039c05e7549ebef0292e8267defa75093bfb1f267e50bc78bcc6c.jpeg",
    "https://cdn.faire.com/fastly/11c61d6d09832e40c2c8358e7043e6ac350e2de5c2178096ad0232a9d9933d04.jpeg",
    "https://cdn.faire.com/fastly/21380d727e487d3eb4f41d1c0a4d395b9af276d0a3f027bf0eb8ab5a02ad90d8.jpeg",
    "https://cdn.faire.com/fastly/e22c3bcfee21f913cdd27e79ae2f5378813acaad4990f572e1100d3904fa3f97.jpeg",
    "https://cdn.faire.com/fastly/13103f4e353de1960e3a597fabb72fd079b090ab29c7ad5645df3acb094de5e6.jpeg",
    "https://cdn.faire.com/fastly/d3bd3827837c3f9ac4bb29ca7478bab228353044dfd23ca3482022bb15de64a0.jpeg",
    "https://cdn.faire.com/fastly/218f8b8ef8abfa040d849f4d642a4d4d15245e1078774c8681eb192db8689b87.jpeg",
    "https://cdn.faire.com/fastly/5cc25e6d60621116f4b451a73a4596800fd52452d0aa25a4480bd72a7452586f.jpeg",
  ],
  priceDollars: 40,
  description:
    "Our dome-shaped LED lamp is a modern lighting solution. The rounded dome top resembles a classic mushroom cap, casting a warm, even glow. With its sleek, minimalist design and energy-efficient LED light, it’s perfect for creating a cozy, playful ambiance in bedrooms, living spaces, or reading nooks. With USB rechargeability, enjoy convenient lighting that adapts to your lifestyle. Multiple colours available.",
  tags: [],
  msrpDollars: 80,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:07.039Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
